import BApp from "../../modules/BApp";
import BModal from "../../modules/BModal";
import BRequest from "../../modules/BRequest";
import BDiaryDay from "./BDiaryDay";

export default class BDiaryDaySearch
{
	constructor(el)
	{
		this.el = el;
	}

	getDiaryDay()
	{
		return new BDiaryDay(this.el.closest(".diary-day"));
	}

	getPreloaderElement()
	{
		return this.el.querySelector(".profile-diary-search__preloader");
	}

	showPreloader()
	{
		this.getPreloaderElement()?.removeAttribute("hidden");
	}

	hidePreloader()
	{
		this.getPreloaderElement()?.setAttribute("hidden", "");
	}

	getNoDataElement()
	{
		return this.el.querySelector(".profile-diary-search__no-data");
	}

	showNoData()
	{
		this.getNoDataElement()?.removeAttribute("hidden");
	}

	hideNoData()
	{
		this.getNoDataElement()?.setAttribute("hidden", "");
	}

	getResultsElement()
	{
		return this.el.querySelector(".profile-diary-search__results");
	}

	setResults(results)
	{
		this.getResultsElement().innerHTML = null;
		for (let result of results) {
			this.getResultsElement().innerHTML += result.templates["diary.searchResult"];
		}
		this.showResults();
	}

	showResults()
	{
		this.getResultsElement()?.removeAttribute("hidden");
	}

	hideResults()
	{
		this.getResultsElement()?.setAttribute("hidden", "");
	}

	getTerm()
	{
		return this.el.querySelector(".profile-diary-search__query").value.trim();
	}

	resetTerm()
	{
		this.el.querySelector(".profile-diary-search__query").value = null;
		this.el.dataset.term = null;
	}

	getAddUrl()
	{
		return this.el.dataset.addUrl;
	}

	search(scenario)
	{
		let term = this.getTerm();
		if (!term) {
			return;
		}
		if (scenario == "term" && term == this.el.dataset.term) {
			return;
		}

		this.el.dataset.term = term;

		this.showPreloader();
		this.hideNoData();
		this.hideResults();

		let url = this.el.dataset.searchUrl;

		let data = {
			query: term,
			limit: 50,
			isAvailable: 1,
			isAllowed: 1,
			isDiaryCompatible: 1,
			tagIds: [],
			templates: [
				"diary.searchResult",
			],
		};

		this.el.querySelectorAll("[name=\"tagIds[]\"]:checked").forEach(el => data.tagIds.push(parseInt(el.dataset.tagId)));

		BRequest.get(url, data).then(response => {
			this.hidePreloader();
			const items = Array.isArray(response.data) ? response.data : (response.data?.items || []);
			if (items.length) {
				this.setResults(items);
			} else {
				this.showNoData();
			}

			BApp.refresh();
		});
	}

	createEntry(diaryDaySearchResult)
	{
		let diaryDay = this.getDiaryDay();

		let url = this.getAddUrl();
		let data = {
			objectId: diaryDaySearchResult.getObjectId(),
			practicalUnitId: diaryDaySearchResult.getPracticalUnitId(),
			amount: diaryDaySearchResult.getAmount(),
		};

		const preloader = diaryDay.getSection("meals").getPreloderTemplate().getElement();
		preloader.querySelector(".template-title").innerHTML = diaryDaySearchResult.el.dataset.title;
		diaryDay.getSection("meals").el.append(preloader);

		BModal.closeAll();

		BRequest.post(url, data, { headers: { ...BDiaryDay.getDiaryWebTemplatesMutationHeaders() }}).then(response => {
			BDiaryDay.applyMutationTemplates(diaryDay, "meals", response.data);
			preloader.remove();

			return BDiaryDay.refreshSidebarAfterMutation(diaryDay);
		}).finally(() => {
			BApp.refresh();
		});
	}
}
